<template>
  <div>
    <CountStorageHeader :img_header="header_image" header="ตรวจสอบการนับสต๊อก" link_back="stock/count_warehouse/countlistwarehouse"/>
    <Warehouse_close/>
  </div>
</template>

<script>
import CountStorageHeader from "@/components/admin/stock/count_storage/headercount_storage/CountStorageHeader";
import HeaderImage from "@/assets/checklist_1.png";
import Warehouse_close from "@/components/admin/stock/count_storage/Warehouse_close";
export default {
  name: "WarehouseClose",
  components: {
    Warehouse_close,
    CountStorageHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
